import { render } from "./liveness-tab.vue?vue&type=template&id=d527439a&ts=true"
import script from "./liveness-tab.vue?vue&type=script&lang=ts"
export * from "./liveness-tab.vue?vue&type=script&lang=ts"

import "./liveness-tab.vue?vue&type=style&index=0&id=d527439a&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__